<template>
  <div class="VehicleRecord">
    <div class="title" :style="`font-size: ${titleFontSize}px;`">车辆识别记录</div>
    <div class="info">
      <div class="list" :style="`font-size: ${listFontSize}px;`">
        <div v-for="(item,index) in list" :key="item.recordId" :class="{first:index===0}" class="item">
          <div class="topInfo">
            <div class="img"><img :src="item.photoUrl" alt="" /></div>
            <div class="rightInfo">
              <div class="userInfo">
                <div class="txt">{{ item.licensePlate }}</div>
                <div class="txt">{{ item.mcName }}</div>
                <div class="txt">{{ item.workerTypeName }}</div>
              </div>
              <div class="inOutInfo">
                <div class="icon">
                  <img v-if="item.direction===1" src="../../../../../../../assets/images/custom-screen/in.png" alt="" />
                  <img v-else src="../../../../../../../assets/images/custom-screen/out.png" alt="" />
                </div>
                <div class="desc">{{ item.direction===1?'进场':'出场' }}</div>
                <div class="time">{{ item.recognitionTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryThroughRecordList } from '@/api/statistics'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  props: {
    personList: {
      type: Array,
      default: () => { return [{}] }
    }
  },
  data() {
    return {
      list: []
    }
  },

  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem,
      lrpEquipmentTimeLog: state => state.socket.lrpEquipmentTimeLog
    }),
    listFontSize() {
      const px = Math.ceil(14 / window.devicePixelRatio)
      return px
    },
    titleFontSize() {
      const px = Math.ceil(18 / window.devicePixelRatio)
      return px
    }
  },
  watch: {
    lrpEquipmentTimeLog(data) {
      if (data.recognitionTime) {
        data.recognitionTime = moment(data.recognitionTime).format('YYYY-MM-DD HH:mm:ss')
      }
      this.list.unshift(data)
    }
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      queryThroughRecordList({
        projectId: this.projectItem.projectId,
        timeStart: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        timeEnd: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        pageSize: 20,
        pageNumber: 1
      }).then(res => {
        this.list = res.data.records
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.VehicleRecord {
  width: 100%;
  height: 100%;
  position: relative;
  .title{
    color: #00cbfe;
    padding-top: 2%;
    text-align: center;
    font-weight: bold;
  }
  .info{
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    .list{
      color: #fff;
      padding: 0 4%;
      .item{
        background: rgba(0, 82, 217, 0.498039215686275);
        width: 100%;
        margin: 0 auto;
        margin-bottom: 10px;
        border-radius: 10px;
        padding: 12px 10px;
        .topInfo{
          display: flex;
        }
        .img{
          width: 30%;
          img{
            width: 100%;
            display: block;
          }
        }
        .txt{
          // margin-top: 10px;
        }
        .rightInfo{
          flex: 1;
          display: flex;
        }
        .userInfo{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-left: 14px;
          flex: 1;
        }

        .inOutInfo{
          line-height: 1.4;
          text-align: center;
          .icon{
            width: 20px;
            height: 15px;
            margin: 0 auto;
            img{
              width: 100%;
            }
          }
          .desc{
            line-height: 1.5;
          }
          .red{
            color: #D61B1F;
          }
          .green{
            color: #00CC00;
          }
        }
      }
      .first{
        .topInfo{
          display: block;
        }
        .img{
          width: 80%;
          margin: 0 auto;
        }
        .rightInfo{
          margin-top: 6px;
        }
      }
    }
  }
}
</style>
